var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("delegationRate.title")))]),
      _c("delegation-info-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "search",
                  label: _vm.$t("global.search"),
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _vm.hasPermissionForEdit
            ? _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-2",
                      attrs: { color: "accent", block: "", dark: "" },
                      on: { click: _vm.addNewTask }
                    },
                    [_vm._v(_vm._s(_vm.$t("delegationRate.newRate")))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-data-table", {
        attrs: { headers: _vm.headers, items: _vm.items, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.country_symbol))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.region))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.currency))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.amount))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.hotel_limit))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.group != null
                            ? props.item.group.name
                            : _vm.$t("delegationRate.basic")
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "td",
                    {
                      staticClass:
                        "justify-center layout px-0 datatable-action-column-field"
                    },
                    [
                      _vm.hasPermissionForEdit
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: { icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editItem(props.item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("edit")])],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: { icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteItem(props.item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("delete")])],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }